import React from "react";
import { Stack, Typography } from "@mui/material";

import { AnimatedText } from "./AnimatedText/AnimatedText";
import { AnimatedPen } from "./AnimatedPen/AnimatedPen";
import { SmokeVideo } from "./SmokeVideo/SmokeVideo";

export const WbMainInfo: React.FC = () => {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      position="relative"
    >
      <SmokeVideo />

      <Typography
        width={1}
        color="primary.contrastText"
        whiteSpace="pre-line"
        textAlign="end"
        fontWeight={200}
        sx={{
          fontSize: {
            md: "1.4rem",
            sm: "1rem",
            xs: "1rem",
          },
        }}
      >
        Beyond the generic{" "}
        <Typography
          color="primary.main"
          component="span"
          fontWeight={200}
          sx={{
            fontSize: {
              md: "1.4rem",
              sm: "1rem",
              xs: "1rem",
            },
          }}
        >
          Apple intelligence
        </Typography>{" "}
        is your{" "}
        <Typography
          color="primary.main"
          component="span"
          fontWeight={200}
          sx={{
            fontSize: {
              md: "1.4rem",
              sm: "1rem",
              xs: "1rem",
            },
          }}
        >
          Own!
        </Typography>
        {"\n"}
        Automate your expertise with
      </Typography>

      <Stack
        width={1}
        direction="column"
        alignItems="center"
        justifyContent="center"
        position="relative"
      >
        <AnimatedText />
        <AnimatedPen />
      </Stack>

      <Typography
        color="secondary"
        variant="h5"
        fontWeight={300}
        textAlign="center"
        sx={{
          marginTop: {
            md: 4,
            xs: 2,
          },
          fontSize: {
            md: "1.5rem",
            xs: "1.2rem",
          },
        }}
      >
        Save time, effort, and boost your work with “Write Better”
      </Typography>
    </Stack>
  );
};
